import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatFormField } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { IOption } from 'src/app/types/option';

/**
 * Riege select component
 * is a generell select form field implementation
 * options input parameter of type {@type IOption} is required
 * label and (pre)selectedOption are optional string parameters
 * NOTE: i18n translation of label has to be done in parent component
 * @class SelectComponent
 * @typedef {SelectComponent}
 */
@Component( {
    selector: 'riege-select',
    imports: [MatFormField, MatSelectModule, NgIf],
    templateUrl: './select.component.html',
    styleUrl: './select.component.scss',
    standalone: true
} )
export class SelectComponent {
    /**
     * label
     * @type {?string}
     */
    @Input() label?: string;
    /**
     * options
     * @type {IOption[]}
     */
    @Input() options: IOption[] = [];
    /**
     * selectedOption
     * @type {?string}
     */
    @Input() selectedOption?: string;

    /**
     * selectionChanged
     * @readonly
     * @type {*}
     */
    @Output() readonly selectionChanged = new EventEmitter();

    /**
     * value of selected option
     * @param {(string | string[])} value
     */
    onChange( value: string | string[] ) {
        this.selectionChanged.emit( value );
    }
}
